<div class="flex justify-between items-center pb-4">
  <h5 class="title-3 my-2">Manage Internal Users</h5>
  @if (dataTable) {
    <button
      pButton
      type="button"
      severity="secondary"
      label="Clear All Filters"
      icon="pi pi-filter-slash"
      data-test-id="clear-filters-button"
      [disabled]="isClearAllEnabled()"
      (click)="resetFilters()"
    ></button>
  }
</div>
<p-table
  #dt
  dataKey="email"
  class="table-paginator"
  [value]="users"
  [lazy]="true"
  (onLazyLoad)="getUsers($event)"
  (onRowExpand)="onRowExpand($event)"
  [columns]="cols"
  [paginator]="true"
  [rows]="amountOfRows"
  [totalRecords]="totalRecords"
  [filterDelay]="1000"
  [loading]="isLoading"
  [sortOrder]="defaultSortOrderOnLoad"
  [defaultSortOrder]="defaultSortOrder"
  [sortField]="defaultSortField"
  [scrollable]="true"
  [showCurrentPageReport]="true"
  responsiveLayout="scroll"
  [resetPageOnSort]="true"
  [alwaysShowPaginator]="false"
  [rowsPerPageOptions]="[5, 10, 20]"
  currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
  >
  <ng-template pTemplate="header">
    <tr>
      <th class="w-8"></th>
      <th pSortableColumn="email" style="min-width: 24rem">
        <div class="flex items-center gap-2">
          Business Email
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="email"
            >
          </p-sortIcon>
        </div>
      </th>
      <th pSortableColumn="displayName" style="min-width: 24rem">
        <div class="flex items-center gap-2">
          Display Name
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="displayName"
            >
          </p-sortIcon>
        </div>
      </th>
      <th style="width:50px" pSortableColumn="isApproved">
        <div class="flex items-center gap-2">
          Active
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="isApproved"
          />
        </div>
      </th>
      <th style="width:20px"></th>
    </tr>

    <tr class="header-filter">
      <th class="w-8"></th>
      <th style="min-width: 24rem">
        <div class="relative autocomplete-icon-align" [style.width.%]="100">
          <p-iconfield>
            <p-inputicon class="pi pi-search" (click)="emailsLisInput.inputEL?.nativeElement.focus()"/>
            <p-autoComplete
              #emailsLisInput
              appendTo="body"
              placeholder="Search"
              [style]="{ width: '100%', display: 'block' }"
              [inputStyle]="{ width: '100%' }"
              delay="500"
              [minQueryLength]="3"
              [suggestions]="filtersData"
              [(ngModel)]="email"
              (completeMethod)="fetchSuggestions($event.query, 'email')"
              (onSelect)="onAutocompleteSelect($event, 'email')"
              (onClear)="onClearAutocomplete('email')"
            />
          </p-iconfield>
        </div>
      </th>
      <th style="min-width: 24rem">
        <div class="relative autocomplete-icon-align" [style.width.%]="100">
          <p-iconfield>
            <p-inputicon class="pi pi-search" (click)="displayNameInput.inputEL?.nativeElement.focus()"/>
            <p-autoComplete
              #displayNameInput
              appendTo="body"
              placeholder="Search"
              [style]="{ width: '100%', display: 'block' }"
              [inputStyle]="{ width: '100%' }"
              delay="500"
              [minLength]="3"
              [suggestions]="filtersData"
              [(ngModel)]="displayName"
              (completeMethod)="fetchSuggestions($event.query, 'displayName')"
              (onSelect)="onAutocompleteSelect($event, 'displayName')"
              (onClear)="onClearAutocomplete('displayName')"
            />
          </p-iconfield>
        </div>
      </th>
      <th>
        <p-select
          placeholder="Filter"
          styleClass="max-w-64"
          [options]="activesList"
          [showClear]="true"
          (onChange)="applyFilterTableValue($event.value, 'isApproved', 'eq')"
          [(ngModel)]="isActive"
          appendTo="body"
        />
      </th>
      <th class="w-8"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">
        <p>{{ isLoading ? 'Loading... please wait' : 'No record found' }}</p>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-user let-columns="columns" let-expanded="expanded">
    <tr>
      <td class="py-0! w-8">
        <button
          type="button"
          pButton
          class="transition-transform! duration-300"
          icon="pi pi-chevron-right"
          [rounded]="true"
          [text]="true"
          [pRowToggler]="user"
          [class]="{ 'rotate-90': expanded }"
        ></button>
      </td>
      <td>
        <div class="text-truncate">
          {{ user.email }}
        </div>
      </td>
      <td>
        {{ user.displayName }}
      </td>
      <td class="w-8">
        <div class="flex items-center gap-2 leading-none">
          <p-toggle-switch
            [ngModel]="user.isApproved"
            [accessEnableSubmit]="['InternalUser.Write']"
            [appChangeUserStatusV2]="user"
            (statusChanged)="onUserStatusChanged()"
            title="Activate or In-Activate An User. On Activation Password Setup Email Will Be Sent."
          />
          <span>
            {{ user.isApproved ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </td>
      <td class="py-0! w-8">
        <button
          pButton
          type="button"
          class="p-button-text"
          icon="pi pi-pencil"
          aria-label="Edit User"
          title="Edit User"
          (click)="editUser(user.userId)"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template #expandedrow let-user>
    <tr>
      <td colspan="5">
        <app-internal-user-groups [userId]="user.userId" />
      </td>
    </tr>
  </ng-template>
</p-table>
